// extracted by mini-css-extract-plugin
export default {"inputs":"EditWarrantySlideIn_inputs__WSyGc","cancelledLabel":"EditWarrantySlideIn_cancelledLabel__e-QXs"};